import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  actions as virtualCardActions,
  selectors as virtualCardSelectors,
} from '@ott/shared-virtual-card-logic';

import { IframeDataAdaptedType, ThreeDSAuthResult, ThreeDSTwoAuthAdapted } from '../../../types';
import { isThreeDSTwoAuth } from '../helpers/threeDSSteps';

const useThreeDSAuth = ({
  iframeData,
  onResult,
  onError,
}: {
  iframeData: IframeDataAdaptedType;
  onResult: (result: ThreeDSAuthResult) => void;
  onError: VoidFunction;
}): void => {
  const dispatch = useDispatch();

  const check3ds = useSelector(virtualCardSelectors.getCheck3ds);

  const pollingHandler = useCallback(
    (value: ThreeDSTwoAuthAdapted) => {
      const { threeDSMethodData, TermUrl } = value;
      const processId = TermUrl.split('/')[5];

      dispatch(virtualCardActions.check3ds({ threeDSMethodData, processId }));
    },
    [dispatch]
  );

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (isThreeDSTwoAuth(iframeData) && (!check3ds.error || !check3ds.data)) {
      const timerId = window.setInterval(() => {
        pollingHandler(iframeData);
      }, 1000);

      return () => {
        clearInterval(timerId);
      };
    }
  }, [check3ds.data, check3ds.error, iframeData, pollingHandler]);

  useEffect(() => {
    if (check3ds.data && !check3ds.data.continue) {
      onResult({ result: check3ds.data, errorCode: check3ds.data.error });
    }
  }, [check3ds.data, onResult]);

  useEffect(() => {
    if (check3ds.error) {
      onError();
    }
  }, [check3ds.error, onError]);
};

export default useThreeDSAuth;
